import * as React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
  d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z"
}), /*#__PURE__*/React.createElement("circle", {
  cx: "8",
  cy: "14",
  r: "2"
}), /*#__PURE__*/React.createElement("circle", {
  cx: "12",
  cy: "8",
  r: "2"
}), /*#__PURE__*/React.createElement("circle", {
  cx: "16",
  cy: "14",
  r: "2"
})), 'GroupWorkOutlined');


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/icons/esm/GroupWorkOutlined.js
// module id = 4061
// module chunks = 2